import React, { ReactNode } from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import { Container } from '@consumer-frontend/shared-ui';

import { NcLoadingSpinner } from '../NcLoadingSpinner';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/loading-page.scss';

export type NcLoadingPagePropsT = {
  className?: string;
  message?: ReactNode;
};
export type NcLoadingPageT = React.FC<NcLoadingPagePropsT>;

export const NcLoadingPage: NcLoadingPageT = ({ className, message }) => {
  return (
    <Container className={mergeClassNameStrings('nc-loading-page', className)}>
      <h1 className="h2">{message ?? 'Loading...'}</h1>
      <NcLoadingSpinner />
    </Container>
  );
};
